class AnnouncementCountdown {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.countdown).getTime();
    this.daysEl = element.querySelector('.countdown-days .countdown-number');
    this.hoursEl = element.querySelector('.countdown-hours .countdown-number');
    this.minutesEl = element.querySelector('.countdown-minutes .countdown-number');
    this.secondsEl = element.querySelector('.countdown-seconds .countdown-number');
    
    if (isNaN(this.endDate)) {
      console.error('Invalid countdown date format');
      return;
    }
    
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }
  
  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;
    
    if (distance < 0) {
      clearInterval(this.interval);
      this.element.style.display = 'none';
      return;
    }
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
  
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const countdowns = document.querySelectorAll('.announcement-bar--countdown');
  countdowns.forEach(countdown => new AnnouncementCountdown(countdown));
});

